import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

export default function TrustFAQ() {
  const { t } = useTranslation();
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  // i18next-http-backend loads translations asynchronously; before they
  // resolve, t(key, { returnObjects: true }) returns the key STRING rather
  // than the array. Guard so a non-array result renders an empty list instead
  // of crashing with ".map is not a function" (see issue #934).
  const rawFaqItems = t("subscription.faqItems", { returnObjects: true });
  const faqItems = Array.isArray(rawFaqItems)
    ? (rawFaqItems as { q: string; a: string }[])
    : [];

  return (
    <div className="px-5 py-9">
      <h3 className="mb-5 text-center text-[15px] font-semibold tracking-tight">
        {t("subscription.commonQuestions")}
      </h3>
      <ul className="mx-auto max-w-2xl">
        {faqItems.map((item, i) => {
          const open = i === openIdx;
          return (
            <li key={i} className="border-b border-border/60 first:border-t">
              <button
                type="button"
                aria-expanded={open}
                onClick={() => setOpenIdx(open ? null : i)}
                className="flex w-full items-center justify-between gap-3 py-3 text-left text-[13px] font-medium hover:text-secondary"
              >
                <span>{item.q}</span>
                <ChevronDown
                  size={14}
                  className={cn(
                    "shrink-0 text-muted-foreground transition-transform duration-200",
                    open && "rotate-180",
                  )}
                />
              </button>
              {open && (
                <p className="border-l-2 border-border/50 pb-3.5 pl-4 text-[12.5px] leading-relaxed text-muted-foreground">
                  {item.a}
                </p>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
